/*
 * @Author: liyxt
 * @Date: 2019-10-21 14:15:59
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:47:49
 * @Description: file content
 */
/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import OriginIcon from 'bee-icon';
require('bee-icon/build/Icon.css');

export default class Icon extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <OriginIcon {...this.props} />;
	}
}

